export type ImpersonnalisationResult = {
  userId: string
  nom: string | null
  prenom: string | null
  email: string
  token: string
}

export interface IImpersonnalisationProvider {
  getImpersonnalisationAsync(to: string): Promise<ImpersonnalisationResult>
}

export const PREFERENCES_IMPERSONNALISATION = 'impersonnalisation' as const